import type { EntityKind } from "./types";
import type {
  EntityKindDashboardConfig,
  RmsDashboardConfig,
} from "../Data/dashboardConfig";

/**
 * Default dashboard configs per entity kind: nothing configured. The panel layout keys (`mode`,
 * `left`, `middle`, `middle_top`, `middle_bottom`, `right`) were dropped in #13370 round 17:
 * nothing has read them since the fixed Overview (#11426), and the record page's layout is set
 * in Appearance. Every remaining setting has its own fallback where it is read.
 */
export const DEFAULT_DASHBOARD_CONFIGS: Record<
  EntityKind,
  EntityKindDashboardConfig
> = {
  manager: {},
  person: {},
  company: {},
  client: {},
  vehicle: {},
  topic: {},
  portfolio: {},
  deal: {},
  // Interaction entities don't have a dashboard, but we include them
  // so the Record is exhaustive.
  interaction: {},
};

/**
 * Resolve the dashboard config for a given entity kind: the org's stored
 * settings laid over the built-in default, so an absent key falls back.
 */
export function getEntityKindConfig(
  entityKind: EntityKind,
  orgConfig: RmsDashboardConfig | undefined
): EntityKindDashboardConfig {
  const stored = orgConfig?.[entityKind];
  if (!stored) return DEFAULT_DASHBOARD_CONFIGS[entityKind];
  return { ...DEFAULT_DASHBOARD_CONFIGS[entityKind], ...stored };
}
